"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.FilterDef = exports.Filter = void 0;
exports.convertToFilters = convertToFilters;
exports.filtersToQueryParams = filtersToQueryParams;
var _reduce = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/reduce"));
var _flat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/flat"));
var _values = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/values"));
var _isArray = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/array/is-array"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var T = _interopRequireWildcard(require("prop-types"));
function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { _Object$defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const Filter = T.shape({
  queryKey: T.string,
  queryValue: T.string,
  urlKey: T.string,
  urlValue: T.string,
  bubbleText: T.string,
  shouldUseToQuery: T.bool,
  shouldUseInUrl: T.bool,
  shouldDisplayBubble: T.bool
});
exports.Filter = Filter;
const FilterDef = T.shape({
  name: T.string,
  iconClassName: T.string,
  multiSelect: T.bool,
  displayId: T.string,
  placeholderId: T.string,
  sort: T.string,
  hideClearBtn: T.bool,
  defaultValue: T.string,
  showRemoveBtn: T.bool,
  // These are filter specific properties:
  properties: T.object,
  allowCustomInput: T.bool,
  items: T.array,
  ranges: T.string
});

/**
 * Translates passed filters into a correspondinq query params.
 * @param  {Object} filters    Applied filters
 * @return {Object}            Query params
 */
exports.FilterDef = FilterDef;
function filtersToQueryParams(filters = {}) {
  var _context, _context2;
  return (0, _reduce.default)(_context = (0, _flat.default)(_context2 = (0, _values.default)(filters)).call(_context2)).call(_context, (queryParams, filter) => {
    const {
      queryKey,
      queryValue,
      shouldUseToQuery
    } = filter;
    const filterParam = queryParams[queryKey];
    if (!shouldUseToQuery) {
      return queryParams;
    }
    if ((0, _isArray.default)(filterParam)) {
      return {
        ...queryParams,
        [queryKey]: [...filterParam, queryValue]
      };
    } else if (filterParam) {
      return {
        ...queryParams,
        [queryKey]: [filterParam, queryValue]
      };
    } else {
      return {
        ...queryParams,
        [queryKey]: queryValue
      };
    }
  }, {});
}
function convertToFilters(selectedItems, filterName) {
  if ((0, _isArray.default)(selectedItems)) {
    return (0, _map.default)(selectedItems).call(selectedItems, item => {
      return {
        urlKey: item.urlKey || filterName,
        urlValue: item.urlValue,
        queryKey: item.queryKey || item.urlKey || filterName,
        queryValue: item.queryValue || item.urlValue,
        bubbleDisplayId: item.bubbleDisplayId,
        bubbleText: item.bubbleText || item.urlValue,
        shouldUseToQuery: item.shouldUseToQuery || true,
        shouldUseInUrl: item.shouldUseInUrl || true,
        shouldDisplayBubble: item.shouldDisplayBubble || true
      };
    });
  } else {
    return [{
      urlKey: selectedItems.urlKey || filterName,
      urlValue: selectedItems.urlValue,
      queryKey: selectedItems.queryKey || selectedItems.urlKey || filterName,
      queryValue: selectedItems.queryValue || selectedItems.urlValue,
      bubbleDisplayId: selectedItems.bubbleDisplayId,
      bubbleText: selectedItems.bubbleText || selectedItems.urlValue,
      shouldUseToQuery: selectedItems.shouldUseToQuery || true,
      shouldUseInUrl: selectedItems.shouldUseInUrl || true,
      shouldDisplayBubble: selectedItems.shouldDisplayBubble || true
    }];
  }
}